import script from "./AlternativeList.vue?vue&type=script&setup=true&lang=js"
export * from "./AlternativeList.vue?vue&type=script&setup=true&lang=js"

import "./AlternativeList.vue?vue&type=style&index=0&id=a4ba8f82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4ba8f82"]])

export default __exports__